import React from 'react';
import { useMenuContext } from '../menuContext';

const MenuOverlay = () => {
  const [state, dispatch] = useMenuContext();
  const isAnyOpen = state.some(({ isOpen }) => isOpen);
  const handleClick = () => {
    dispatch({ type: 'closeAll' });
  };
  return <div className="navigation__overlay" hidden={!isAnyOpen} onClick={handleClick} />;
};

export default MenuOverlay;
